import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 update_product_viewable_on_webstore: { message: "idle" },
};

export const update_product_viewable_on_webstore_Slice = createSlice({
 name: "update_product_viewable_on_webstore",
 initialState,
 reducers: {
  success_update_product_viewable_on_webstore: (state, action) => {
   state.update_product_viewable_on_webstore = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_update_product_viewable_on_webstore: (state, action) => {
   state.update_product_viewable_on_webstore = { status: app_consts.FAIL, message: action.payload };
  },
  reset_update_product_viewable_on_webstore: (state) => {
   state.update_product_viewable_on_webstore = { status: app_consts.IDLE };
  },
  loading_update_product_viewable_on_webstore: (state) => {
   state.update_product_viewable_on_webstore = { status: app_consts.LOADING };
  },
 }
});

export const { success_update_product_viewable_on_webstore, fail_update_product_viewable_on_webstore, reset_update_product_viewable_on_webstore, loading_update_product_viewable_on_webstore } = update_product_viewable_on_webstore_Slice.actions;

export default update_product_viewable_on_webstore_Slice.reducer;